(function () {
	'use strict';
	angular.module('app.setup')
		.controller('sftpPublicKeyForm', sftpPublicKeyForm);

	sftpPublicKeyForm.$inject = ['$scope', 'sftpConfigService'];
	function sftpPublicKeyForm($scope, sftpConfigService) {
		var vm = this;
		vm.siteId = $scope.siteId;
		vm.isSaveButtonDisabled = false;
		vm.action = $scope.action;
		vm.close = close;
		vm.save = save;
		vm.reset = reset;
		vm.parseSSHLabel = parseSSHLabel;
		

		vm.pastedSSHPublicKey = '';
		vm.sshKey = {};
		vm.sshKey.sshLabel = '';
		vm.sshKey.sshPublicKeyBody = '';



		function parseSSHLabel() {
			if (!vm.sshKey.sshLabel) {
				if (vm.pastedSSHPublicKey) {
					vm.sshKey.sshLabel = vm.pastedSSHPublicKey.split(' ').slice(2).join(' ');
				}
			}
		}

		function save() {
			vm.isSaveButtonDisabled = true;
			vm.sshKey.sshPublicKeyBody = vm.pastedSSHPublicKey.split(' ', 2).join(' ');
			sftpConfigService.uploadSFTPKey(vm.siteId,vm.sshKey).then(function (message) {
				if (_.isString(message)) {
					$scope.result(message, false);
				} else {
					$scope.result('SSH Public Key uploaded successfully', true);
				}
				vm.isSaveButtonDisabled = false;
			});

		}

		function reset() {
			vm.pastedSSHPublicKey = '';
			vm.sshKey = {};
		}

		function close() {
			$scope.result('', false);
		}
	}
})();
